module.exports = __webpack_public_path__ + "img/icon_android_down_code.f1206961.png";